"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailableLanguages = exports.supportedLocales = void 0;
exports.supportedLocales = {
    'hi-IN': {
        label: 'हिंदी',
        languageTag: 'hi-IN',
        isRTL: false,
        getter: () => require('./translations/hi-IN.json'),
    },
    'en-US': {
        label: 'English (US)',
        languageTag: 'en-US',
        isRTL: false,
        getter: () => require('./translations/en-US.json'),
    },
    'en-GB': {
        label: 'English (UK)',
        languageTag: 'en-GB',
        isRTL: false,
        getter: () => require('./translations/en-US.json'),
    },
    'en-AU': {
        label: 'English (AU)',
        languageTag: 'en-AU',
        isRTL: false,
        getter: () => require('./translations/en-US.json'),
    },
    'de-DE': {
        label: 'Deutsche',
        languageTag: 'de-DE',
        isRTL: false,
        getter: () => require('./translations/de-DE.json'),
    },
    'zh-CN': {
        label: '简体中文',
        languageTag: 'zh-CN',
        getter: () => require('./translations/zh-CN.json'),
    },
    'es-ES': {
        label: 'Español (Spain)',
        languageTag: 'es-ES',
        isRTL: false,
        getter: () => require('./translations/es-ES.json'),
    },
    'es-US': {
        label: 'Español (US)',
        languageTag: 'es-US',
        isRTL: false,
        getter: () => require('./translations/es-ES.json'),
    },
};
/**
 * Returns list of languages
 */
function getAvailableLanguages() {
    return Object.values(exports.supportedLocales).map(x => ({
        label: x.label,
        languageTag: x.languageTag,
    }));
}
exports.getAvailableLanguages = getAvailableLanguages;
//# sourceMappingURL=languages.js.map